import React, { LegacyRef, forwardRef } from "react";

type InputProps = {
  label?: string;
  helperText?: string;
  error?: boolean;
  containerClass?: string;
  containerRef?: LegacyRef<HTMLDivElement>;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const Select = forwardRef<HTMLSelectElement, InputProps>(
  (
    {
      label,
      helperText,
      error,
      containerClass,
      children,
      containerRef,
      ...props
    },
    ref
  ) => {
    return (
      <div className={containerClass}>
        {!!label && (
          <label
            {...(props.id && { htmlFor: props.id })}
            className="mb-2 font-semibold"
          >
            {label}
            {props.required && <span className="text-red-500">{" *"}</span>}
            {/* {props.required ? `${label} *` : label} */}
          </label>
        )}
        <div
          className={`border border-gray-400 rounded-lg pr-3 ${
            props.disabled ? "bg-gray-200" : ""
          }`}
          ref={containerRef}
        >
          <select
            {...props}
            ref={ref}
            className={`${
              props.className || ""
            } block w-full py-3.5 px-4 placeholder:px-0 rounded-lg bg-white relative disabled:bg-gray-200 ${
              error ? "border-red-500" : ""
            }`}
          >
            {children}
          </select>
        </div>
        {!!helperText && (
          <p className={error ? "text-red-500" : ""}>{helperText}</p>
        )}
      </div>
    );
  }
);

export default Select;
